import React, { useEffect } from "react";

import TablaContrato from "./TablaContrato";
import { dbx } from "../../../utils/urlBack_End";
import { empleadosApi } from "src/services/empleadosApi";

export default function Contratos(props) {
  const {
    valueLaboral,
    empleado,
    setShowMessagePermiso,
    setColor,
    setMessage,
    vista,
  } = props;
  const { data } = empleadosApi.useGetContratoEmpleadoQuery(empleado.rut);
  const contratos = data ?? [];

  useEffect(() => {
    if (empleado.rut !== undefined) {
      dbx
        .filesListFolder({ path: `/Empleados/${empleado.rut}/Contratos` })
        .then(() => {})
        .catch(() => {
          dbx
            .filesCreateFolderV2({
              path: `/Empleados/${empleado.rut}/Contratos`,
            })
            .then((response) => {})
            .catch((error) => {});
        })
        .finally(() => {});
    }
  }, [empleado.rut]);
  return (
    <>
      {valueLaboral === 1 && (
        <>
          <TablaContrato
            contratos={contratos}
            empleado={empleado}
            setShowMessagePermiso={setShowMessagePermiso}
            setColor={setColor}
            setMessage={setMessage}
            vista={vista}
          />
        </>
      )}
    </>
  );
}
